<template>
  <div class="compayBox">
    
    <div class="compay bg_fff flex">

      <!-- 左侧菜单 -->
      <div class="compay_left">
        <div class="header">
          <div class="title f_22 color_40 font_w_b">编辑公司信息</div>
          <div class="tips f_12 color_60">完善的公司介绍，能获得更多求职者的青睐，为你带来更多查看与沟通</div>
        </div>
        <div class="companyNav">
          <div class="item transition_1 flex-c cursor_p pr" v-for="(item,index) in companyNav" :key="String(index)" :class="[index===companyTabIndex?'active':'']" @click="toggleCompanyTabIndex(index)">
            <span class="flex1 f_14 color_40">{{item}}</span>
            <span class="iconfont iconyemiantiaozhuan color_9c"></span>
          </div>
        </div>
      </div>
      <div class="compay_right flex1" v-loading="isLoading">
        <rightContent :firstFlag="firstFlag"/>
        <rightContent2/>
        <rightContent3/>
        <rightContent4/>
        <rightContent5/>
      </div>
    </div>

  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'

import { mapState, mapMutations } from 'vuex'
import { getValLenngth, get_tUser } from '@/utils/utils'
import company_options from '@/utils/company_options'
const oss = require('ali-oss');

import rightContent from '@/components/company/rightContent'
import rightContent2 from '@/components/company/rightContent2'
import rightContent3 from '@/components/company/rightContent3'
import rightContent4 from '@/components/company/rightContent4'
import rightContent5 from '@/components/company/rightContent5'

export default {
  name: 'talentCompany',
  data(){
    return {
      isLoading:true,
      backTo:'', //保存之后返回的地址
      companyNav:['公司基本信息','公司介绍','公司福利','公司相册','产品介绍','高管介绍'], //公司navbar
      ossTime:null,
      firstFlag: false
    }
  },
  computed:{
    ...mapState('block', ['userInfo','userInfoState', 'userinfoTipsState']),
    ...mapState('company', ['companyData', 'companyTabIndex'])
  },
  components:{
    rightContent,
    rightContent2,
    rightContent3,
    rightContent4,
    rightContent5
  },
  async created(){
    this.userJWT = get_tUser();
    //读取保存之后返回的地址
    let { backTo='', edit } = this.$route.query;
    // 是否从url传递的参数
    this.backTo = backTo;
    // 已经是hr了
    if(this.userJWT.h_t){
      this.getUserinfo();
    }else{
      // 还不是hr 是新用户
      // this.$router.replace({ path: '/talent/binduser' })
      window.location.href = `${window.location.origin}/talent/binduser?link_to=${encodeURIComponent(encodeURIComponent(window.location.href))}`
      // 修改信息完整状态
      this.toggleUserInfoState(false);
      return false;
    }
    clearInterval(this.ossTime);
    this.updateCompanyTabIndex(0)
  },
  beforeDestroy(){
    clearInterval(this.ossTime)
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState','toggleUserinfoTips','updateOssOptions']),
    ...mapMutations('company',['updateCompanyData','updateCompanyTabIndex']),
    // 获取用户信息
    async getUserinfo(){
      let userInfo = await actions.hr_accounts.getUserinfo();
      this.toggleUserInfoState(userInfo);
      let { company_name, cust_company_name, company_token} = userInfo;
      // 用户信息保存完整，首次进入进入不可编辑状态
      if(this.userInfoState) {
        this.isLoading = false;
      } else {
        // 需要hr权限
        window.location.href = `${window.location.origin}/talent/binduser?link_to=${encodeURIComponent(encodeURIComponent(window.location.href))}`;
        return
      }
      if(company_token){
        //获取公司信息
        this.getCompanyData(company_token);
      }
      //获取oss参数
      this.getOssData();
    },
    //【公司】获取公司详情
    getCompanyData(token){
      actions.company.get_company_companies(token,{type:'hr'}).then(res=>{
        if(res.code === 1000){
          let { company_website_url, company_website_url_hr, size_min, size_max, logo, logo_hr, description, description_hr, benefits, industry_id,industry } = res.data;
          //网址判断
          res.data.company_website_url_hr = company_website_url_hr || company_website_url || '';
          //logo判断
          res.data.logo_hr = logo_hr || logo || '';
          //描述判断
          res.data.description_hr = description_hr || description || '';
          //公司规模
          res.data.size = ''
          if(size_max){
            company_options.scale_options.forEach(item=>{
              if(size_max<=item.max && !res.data.size){
                res.data.size = item.value
              }
            })
          }
          //整理福利
          let benefit_detail = [];
          for(let i=0; i<4; i++){
            let bitem = {
                  id:i,
                  list:[]
                }
            benefits.benefit_detail && benefits.benefit_detail.forEach((item,index)=>{
              if(item.id===i){
                bitem = item
              }
            })
            benefit_detail.push(bitem)
          }
          //整理行业id
          if(industry_id && industry && industry.cn){
            company_options.industry_options.forEach(item=>{
              if(industry.cn === item.label){
                res.data.industry_id = item.value
              }
            })
          }
          benefits.benefit_detail = benefit_detail;
          this.updateCompanyData(res.data)
          this.firstFlag = true
        }
      })
      /*let res = {
        "code": 1000,
        "message": "success",
        "data": {
            "industry_id": 36, //行业id
            "token": "d87b1f8a75a511ea9f1000163e1235c8", //保存id
            "company_full_name": "大参林医药集团股份有限公司", //公司名称
            company_nick_name:'大参林',//简称
            "company_website_url": "www.dslyy.com", //库里的网址
            "company_website_url_hr": null, //hr自己填写的网址
            scale:'',//公司规模合并之后数据
            "size_min": 3000, //公司规模
            "size_max": 3999,//公司规模
            "logo": "https://logo.wondercv.cn/companies/d88abe3675a511ea9f1000163e1235c8.jpg", //库里的logo
            "logo_hr": null, //hr自己填写的logo
            "company_type": "民营", //公司类型
            "phase": 'B轮', 
            "description": "大参林医药集团股份有限公司成立于1999年，是集药品生产、销售为一体的集团化企业。公司以发展药店连锁为立业之本，经过多年发展，2015年年底，直营连锁门店近2000间，员工近18000名。", //描述
            "description_hr": null,//hr自己填写的描述
            "intro_picture": ['1.jpg','2.jpg'], //公司相册
            "executive": [ //高层
              {
                "id": 1,
                "name": "李白",
                "position": "ceo",
                "description": "测试试试你ihi是生死时速",
                "avatar": "https://file.wondercv.com/ASDAWFAF.jpg",
              }
            ],
            "benefit": { //公司福利
              "id": 1,
              "start_at": "10:00",
              "end_at": "14:00",
              "overtime": 1, //加班情况
              "rest": 1, //休息时间
              "benefit_detail": [{
                "id": 0,
                list:[
                  {
                    id:0
                  }
                ]
              },{
                "id": 2,
                list:[
                  {
                    id:0
                  }
                ]
              }]
            },
            "products": [ //产品/服务介绍
              {
                "id": 7898,
                "pro_name": "大参林",//产品名称
                "pro_description": "大参林医药集团股份有限公司是集医药零售、医药制造以及医药批发为一体的集团化企业。", //产品描述
                "pro_logo": "https://logo.wondercv.cn/products/d8ada3ce75a511ea9f1000163e1235c8.jpg" //产品logo
              }]
        }
      }*/
      
    },
    toggleCompanyTabIndex(index){
      if(index!==0){
        if(this.userInfo.company_token !== this.companyData.token){
          this.$message({
            message: '请先绑定公司',
            iconClass:'el-icon-error',
          });
          return false;
        }
        // this.$message({
        //     message: '请先完善公司信息',
        //     iconClass:'el-icon-error',
        //   });
        //   return false;
        
      }
      // 切换tab时，清理route中的params showReplaceDialog参数，避免重复触发
      this.$route.params.showReplaceDialog = false

      this.updateCompanyTabIndex(index)
    },
    getOssData(){
      actions.staticApi.get_oss_token({}).then(res=>{
        if(res.code === 1000){
          let { access_key_id, access_key_secret, expiration, request_id,security_token } = res.data;
          // accessKeyId: 'your access key',
          // accessKeySecret: 'your access secret',
          // bucket: 'your bucket name',
          // region: 'oss-cn-hangzhou'
          this.updateOssOptions({
            region: 'oss-cn-beijing',
            accessKeyId: access_key_id,
            accessKeySecret: access_key_secret,
            bucket: 'staging-wondercv-logo',
            stsToken: security_token
          })
          //十分钟重新获取一次
          let ossTimeIndex = 10;
          this.ossTime = setInterval(() => {
            if(ossTimeIndex<=0){
              //清除定时器
              clearInterval(this.ossTime);
              //重新获取oss参数
              this.getOssData();
            }
            ossTimeIndex-=1;
          }, 60*1000);
        }else{

        }
      })
      

      // client.list().then((result) => {
      //   console.log('objects: %j', result.objects);
      //   return client.put('my-obj', new OSS.Buffer('hello world'));
      // }).then((result) => {
      //   console.log('put result: %j', result);
      //   return client.get('my-obj');
      // }).then((result) => {
      //   console.log('get result: %j', result.content.toString());
      // });
    },

    // 错误信息
    errorMessage(){
      let udesk_container = document.querySelector('#udesk_btn a');
      if(udesk_container!=null){
        udesk_container.click();
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@import './Index.scss';

</style>